exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.btn.custom-widget:hover, .btn.custom-widget:focus, .btn.custom-widget:active {\n  background-color: #8ca0b3 !important;\n}\n.btn.custom-widget.delete-btn:hover, .btn.custom-widget.delete-btn:focus, .btn.custom-widget.delete-btn:active {\n  background-color: #f16c64 !important;\n}\n.btn.custom-widget.save-btn:hover, .btn.custom-widget.save-btn:focus, .btn.custom-widget.save-btn:active {\n  background-color: #6ac951 !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-63ff5b85","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/tools/widget/widgetEditor.vue
// module id = 2520
// module chunks = 0